<template>
    <div v-if="isLoading" class="brand-loader-wrapper">
        <brand-loader />
    </div>
    <power-bi-viewer :power-bi-details="powerBiDetails" :no-breadcrumb="props.noBreadcrumb" :display-mode="props.displayMode" :allow-comments-expand="props.allowCommentsExpand" v-else-if="powerBiDetails" />
    <no-pdf-view v-else-if="!isLoading" />
</template>

<script lang="ts" setup>

import { IPowerBiDetails } from '@/interfaces/deltaGpt/IDocument.ts';
import NoPdfView from '@/views/404View.vue';
import { ref } from 'vue';
import { deltaGptApi } from '@/api/deltaGpt/deltaGptApi.ts';
import BrandLoader from '@/components/layout/BrandLoader.vue';
import PowerBiViewer from './PowerBiViewer.vue';

const props = withDefaults(defineProps<{
    documentShortCode: string;
    noBreadcrumb?: boolean;
    displayMode?: 'page' | 'modal';
    allowCommentsExpand?: boolean;
}>(), {
    noBreadcrumb: false,
    displayMode: 'page',
    allowCommentsExpand: true,
});

const powerBiDetails = ref<IPowerBiDetails | undefined>();
const isLoading = ref<boolean>(false);

async function initialise (): Promise<void> {
    isLoading.value = true;
    try {
        powerBiDetails.value = await deltaGptApi.getPowerBiDetails(props.documentShortCode);
    } finally {
        isLoading.value = false;
    }
}

initialise();

</script>

<style lang="scss" scoped>
.brand-loader-wrapper {
    position: relative;
    height: 100%;
    min-height: 0;
}
</style>
